(function () {
    "use strict";
    angular.module("skillBuilderSaaS")
        .controller("DisqusCtrl", ["myAccountResource", "$translate", "$window", disqusCtrl]);
    function disqusCtrl(myAccountResource, $translate, $window) {
        var vm = this;
        vm.disqusEnabled = true;
        myAccountResource.getDisqus(function (data) {
            if (data.shortname)
                loadDisqus(data);
            else
                vm.disqusEnabled = false;
        });
        function loadDisqus(data) {
            $window.disqus_config = function () {
                // The generated payload which authenticates users with Disqus
                this.page.remote_auth_s3 = data.authKey;
                this.page.api_key = data.apiKey;
                this.language = $translate.use().substr(0, 2);
            };
            (function () {
                var d = document, s = d.createElement('script');
                s.src = 'https://' + data.shortname + '.disqus.com/embed.js';
                s.setAttribute('data-timestamp', new Date().getTime().toString());
                (d.head || d.body).appendChild(s);
            })();
        }
    }
}());
